import { UnaryExpression } from "./abstract.unary.expression";
import { FunctionExpression } from "./abstract.functionExpression";

export class ToLowerFunction extends FunctionExpression 
{
    constructor(field: string | UnaryExpression) 
    {
        super("tolower", field);
    }
}
